
import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import workoutApi from '../api';

const localizer = momentLocalizer(moment);

const WorkoutCalendar = ({ memberId }) => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        const fetchWorkoutSessions = async () => {
            // This is a placeholder. You need to implement an endpoint to get workout sessions for a member.
            // const response = await workoutApi.get(`workout-sessions.php?memberId=${memberId}`);
            // const sessions = response.data;

            // Sample data
            const sessions = [
                { session_id: 1, plan_id: 1, member_id: 1, date: '2025-09-15', exercises_completed: '[]', notes: 'Good session', completion_status: 'Completed' },
                { session_id: 2, plan_id: 1, member_id: 1, date: '2025-09-17', exercises_completed: '[]', notes: 'Tough one', completion_status: 'Completed' },
            ];

            const calendarEvents = sessions.map(session => ({
                id: session.session_id,
                title: `Workout Session - ${session.completion_status}`,
                start: new Date(session.date),
                end: new Date(session.date),
                allDay: true,
                resource: session,
            }));
            setEvents(calendarEvents);
        };
        fetchWorkoutSessions();
    }, [memberId]);

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Workout Calendar</h1>
            <div style={{ height: 500 }}>
                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                />
            </div>
        </div>
    );
};

export default WorkoutCalendar;
